<template>
    <div>
        <q-slide-transition v-for="(item, index) in items" :key="item.id">
            <div class="row gutter-xs q-mb-sm q-pb-sm"
                 :class="{ 'bg-grey-gradient': !isEditing(item.id) }">

                <h6 class="q-mt-sm q-mb-none q-mx-sm col-12 row items-center">
                    <slot name="label" :index="index">{{ label }} {{ index+1 | pad(2) }}</slot>
                    <v-button v-if="!isEditing(item.id)"
                              icon="edit" flat rounded dense no-caps
                              color="info" class="no-shadow on-right"
                              @click="edit(item.id)"
                              :label="$T('edit')"></v-button>
                    <v-button icon="delete" flat rounded dense no-caps
                              color="negative" class="no-shadow on-right"
                              :label="$T('delete')">
                        <q-popover>
                            <div class="group text-center">
                                <p><strong>{{ $T('are you sure?') }}</strong></p>
                                <v-button class="no-shadow capitalize"
                                          color="negative"
                                          no-caps rounded
                                          icon="delete"
                                          @click="$delete(items, index)"
                                          v-close-overlay
                                          :label="$t('delete')"></v-button>
                                <v-button class="no-shadow capitalize"
                                          color="faded"
                                          no-caps rounded
                                          v-close-overlay
                                          :label="$t('cancel')"></v-button>
                            </div>
                        </q-popover>
                    </v-button>
                </h6>
                <slot :item.sync="item" :index="index" :is-editing="isEditing(item.id)"></slot>
            </div>
        </q-slide-transition>
    </div>
</template>
<script>
    import {
        QSlideTransition,
        QPopover
    } from 'quasar-framework'

    export default {
        name: 'loopable',

        props: ['items', 'label'],
        methods: {
            isEditing(key) {
                return this.editing === key || this.items.length == 1
            },
            edit(key) {
                this.editing = key
            }
        },
        data() {
            return {
                editing: this.items && this.items[0] ? this.items[0].id : false
            }
        },
        components: {
            QSlideTransition,
            QPopover
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Loopable.vue